/**
 * Translations for the journal feature area.
 */
const journal = {
  zh: {
    'journal.write.pageTitle': '📖 我的日记',
    'journal.write.pageSubtitle': '记录今天发生的事',
    'journal.write.openButton': '✏️ 写一条今天的日记',
    'journal.write.moodHeader': '今天的心情',
    'journal.write.contentHeader': '写点什么吧',
    'journal.write.placeholder': '今天我和...',

    'journal.mood.happy': '开心',
    'journal.mood.excited': '超棒',
    'journal.mood.calm': '平静',
    'journal.mood.sad': '难过',
    'journal.mood.tired': '累了',

    'journal.empty.title': '还没有日记',
    'journal.empty.hint': '把今天发生的事、想到的事，记下来吧～',

    'journal.error.empty': '写点什么吧～',
    'journal.error.generic': '出错了',
  } as Record<string, string>,
  en: {
    'journal.write.pageTitle': '📖 My Journal',
    'journal.write.pageSubtitle': 'Write down what happened today',
    'journal.write.openButton': '✏️ Write today\'s entry',
    'journal.write.moodHeader': 'How do you feel today?',
    'journal.write.contentHeader': 'Write something',
    'journal.write.placeholder': 'Today I...',

    'journal.mood.happy': 'Happy',
    'journal.mood.excited': 'Awesome',
    'journal.mood.calm': 'Calm',
    'journal.mood.sad': 'Sad',
    'journal.mood.tired': 'Tired',

    'journal.empty.title': 'No journal entries yet',
    'journal.empty.hint': 'Jot down what happened, what you thought — anything!',

    'journal.error.empty': 'Write something first!',
    'journal.error.generic': 'Something went wrong',
  } as Record<string, string>,
};

export default journal;
